import { UseMutationResult, UseQueryResult, useMutation, useQuery, useQueryClient } from "react-query";
import useAPI from "../utils/useAPI";
import useControllers from "../utils/useControllers";
import { DeepPartial } from "../../Models/genericInterfaces";
import { IFormaPagamento, IFormaPagamentos } from "../../Models/FormaPagamento";


const useFormaPagamentoController = (updateQueryKey?: string, isArray: boolean = true, enableQuery: boolean = false) : IUseFormaPagamentoController => {
    const API = useAPI();
    const queryClient = useQueryClient();
    const { Update, Delete, Create } = useControllers();

    const primaryKey = 'CD_FORMA';
    const endpoint = 'pagtoForma';

    const mutDeletar = useMutation(
        (data : DeepPartial<IFormaPagamento>) => {
            return API.del(`${endpoint}/deletar/${data[primaryKey]}`, "")
        }, {
            onSuccess: (ret: any, data: DeepPartial<IFormaPagamento>) => {
                if (!!updateQueryKey) {
                    queryClient.setQueryData<IFormaPagamentos>(
                        updateQueryKey,
                        (oldData: any) => {
                            if (oldData) {
                                return Delete(oldData, data);
                            }
                            return oldData;
                        }
                    );
                };
            },
            onError: (error: any) => {
                alert(error)
            }
    });

    const mutAlterar = useMutation(
        (data : DeepPartial<IFormaPagamento>) => {
            return API.put(`${endpoint}/alterar/${data[primaryKey]}`, data)
        }, {
            onSuccess: (ret: any, data: DeepPartial<IFormaPagamento>) => {
                if (!!updateQueryKey) {
                    queryClient.setQueryData<IFormaPagamentos>(
                        updateQueryKey,
                        (oldData: any) => {
                            if (oldData) {
                                return Update(oldData, data, primaryKey, isArray);
                            }
                            return oldData;
                        }
                    );
                };
            },
            onError: (error: any) => {
                alert(error)
            }
    });

    const mutCadastrar = useMutation(
        (data : DeepPartial<IFormaPagamento>) => {
            return API.post(`${endpoint}/cadastrar`, data)
        }, {
            onSuccess: (ret: any, data: DeepPartial<IFormaPagamento>) => {
                if (!!updateQueryKey) {
                    queryClient.setQueryData<IFormaPagamento>(
                        updateQueryKey,
                        (oldData: any) => {
                            if (oldData) {
                                return Create(oldData, ret['Criado']);
                            }
                            return oldData;
                        }
                    );
                };
            },
            onError: (error: any) => {
                alert(error)
            }
    });

    const mutBuscar = useMutation(
        (data : DeepPartial<IFormaPagamento>) => 
            API.get(`${endpoint}/buscar/${data[primaryKey]}`, "")
        , {
            onSuccess: (ret: IFormaPagamento) => {
                // setItem(ret);
            },
            onError: (error: any) => {
                alert(error)
            }
    });

    const qryListar = useQuery<IFormaPagamentos>(
        updateQueryKey!,
        (
            () => API.get(`${endpoint}/buscarTodos`, '', false)
        ),
        {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            retry: 3,
            enabled: enableQuery,
        }
    );    

    return {
        Deletar: mutDeletar,
        Alterar: mutAlterar,
        Cadastrar: mutCadastrar,
        Buscar: mutBuscar,
        Listar: qryListar,
    }
}

export interface IUseFormaPagamentoController {
    Deletar     : UseMutationResult<any, any, DeepPartial<IFormaPagamento>, unknown>;
    Alterar     : UseMutationResult<any, any, DeepPartial<IFormaPagamento>, unknown>;
    Cadastrar   : UseMutationResult<any, any, DeepPartial<IFormaPagamento>, unknown>;
    Buscar      : UseMutationResult<IFormaPagamento, any, DeepPartial<IFormaPagamento>, unknown>
    Listar      : UseQueryResult<IFormaPagamentos, unknown>;
}

export default useFormaPagamentoController;